import React from 'react';
import ContentLoader from 'react-content-loader';

const CartCountdownTimerSkeleton = () => (
  <div className="flex justify-end px-4 mt-4">
    <ContentLoader
      speed={1.4}
      height={24}
      backgroundColor="var(--neutral-200)"
      foregroundColor="var(--neutral-400)"
      className="w-[300px] mx-auto sm:mx-0"
    >
      <rect x="0" y="0" rx="4" ry="4" height="100%" width="100%" />
    </ContentLoader>
  </div>
);

export default CartCountdownTimerSkeleton;
